import { render, staticRenderFns } from "./Chart1.vue?vue&type=template&id=1305736a&scoped=true"
import script from "./Chart1.vue?vue&type=script&lang=js"
export * from "./Chart1.vue?vue&type=script&lang=js"
import style0 from "./Chart1.vue?vue&type=style&index=0&id=1305736a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1305736a",
  null
  
)

export default component.exports